import { overlappingRows } from "./price";
import { alibabaSkus } from "./skus/alibaba";
import { anthropicSkus } from "./skus/anthropic";
import { openaiSkus } from "./skus/openai";
import { openrouterSkus } from "./skus/openrouter";
import { vertexSkus } from "./skus/vertex";
import type { Sku } from "./types";

/** Every SKU Pax can be billed at. */
export const skus: readonly Sku[] = [
  ...alibabaSkus,
  ...anthropicSkus,
  ...openaiSkus,
  ...openrouterSkus,
  ...vertexSkus,
];

const byId = new Map(skus.map(sku => [sku.id, sku]));

const problems = [
  ...skus
    .filter((sku, index) => skus.findIndex(other => other.id === sku.id) !== index)
    .map(sku => `${sku.id} is listed twice`),
  ...skus.flatMap(sku =>
    overlappingRows(sku).map(([row, other]) => `${sku.id}: ${row.id} and ${other.id} overlap`),
  ),
];
if (problems.length > 0) throw new Error(`Price data is inconsistent: ${problems.join("; ")}`);

/** `<billedBy>:<model>:<endpoint>:<tier>`. */
export function skuIdOf(parts: Pick<Sku, "billedBy" | "model" | "endpoint" | "tier">): string {
  return `${parts.billedBy}:${parts.model}:${parts.endpoint}:${parts.tier}`;
}

export function skuById(id: string | undefined): Sku | undefined {
  return id === undefined ? undefined : byId.get(id);
}

/** The SKUs a seller bills for one model, across its endpoints and tiers. */
export function skusOfModel(billedBy: string, model: string): Sku[] {
  return skus.filter(sku => sku.billedBy === billedBy && sku.model === model);
}
